<div class="container-fluid mb-4">
    <div class="row top-title">
      <div class="col-12 mt-2 pb-4">

        <div class="card mb-3 bg-2">
          <div class="card-body">
            <div>
              <app-carteira-pesquisa #pesquisa
                (searchEvent)="searchEvent($event)"
                (dataFetched)="onDataFetched($event)"
                (filterChanged)="onFilterChanged($event)"
              ></app-carteira-pesquisa>
            </div>
            <div class="mt-3">
              <div class="d-flex flex-row justify-content-end mt-2 mb-2">
                <div class="p-2">
                  <mat-slide-toggle [color]="'primary'" [(ngModel)]="ativaEnquadramento">Ativa enquadramento</mat-slide-toggle>
                </div>
                <div class="p-2">
                  <mat-slide-toggle [color]="'primary'" [(ngModel)]="processamentoAuto">Processamento automático</mat-slide-toggle>
                </div>
                <div class="p-2">
                  <button mat-raised-button color="primary" [disabled]="!listaCmp || listaCmp.selectedCarteiras.length === 0" label="Gravar selecionadas"
                          title="Gravar selecionadas"
                          (click)="gravar()">Gravar selecionadas
                  </button>
                </div>
                <div class="p-2">
                  <button mat-raised-button color="primary"  [disabled]="list.totalElements === 0" label="Gravar todas"
                          title="Gravar todas"
                          (click)="confirmarGravarTodas()">Gravar todas
                  </button>
                </div>
              </div>
              <app-total-table [totalRegistros]="list.totalElements" [totalSelecionados$]="totalSelecionados$" *ngIf="list.totalElements && list.totalElements > 0"
                               (onChange)="updatePageSize($event)"></app-total-table>
              <app-carteira-lista #list (itemSelected)="carteiraSelected($event)"></app-carteira-lista>
              <div class="d-flex justify-content-center mt-3">
                <maps-pagination [pageNumber]="page$" [items]="list.totalPages"
                                 *ngIf="list.totalElements && list.totalElements > 0"
                                 (pageSend)="pesquisaCmp.nextPage($event)"></maps-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2"></div>
      </div>
    </div>
</div>
